<template>
  <div class="con">
    <el-form ref="ruleForm" label-width="200px" class="demo-ruleForm">
      <el-form-item label="开启：" prop="name">
        <el-checkbox v-model="list.enabled"></el-checkbox>
      </el-form-item>
      <el-form-item label="通讯协议：" prop="name">
        <el-select placeholder="请选择" v-model="list.wmode" size="mini" class="Form-Input-Width">
          <el-option
            v-for="item in ProtocolList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="网络模式：" prop="name">
        <el-select placeholder="请选择" v-model="list.mode" size="mini" class="Form-Input-Width">
          <el-option
            v-for="item in InternetList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="传输协议：" prop="name">
        <el-select placeholder="请选择" v-model="list.protocol" size="mini" class="Form-Input-Width">
          <el-option
            v-for="item in TransferProtocolList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="串口接受超时(毫秒)：" prop="name">
          <el-input size="mini" class="Form-Input-Width" v-model="list.vtime"></el-input>
      </el-form-item>
      <el-form-item label="协议包大小(字节)：" prop="name">
        <el-input size="mini" class="Form-Input-Width" v-model="list.mtu"></el-input>
      </el-form-item>
      <el-form-item label="心跳：" prop="name">
        <el-checkbox v-model="list.hb"></el-checkbox>
      </el-form-item>
      <el-form-item label="启用ID：" prop="name">
        <el-checkbox v-model="list.id"></el-checkbox>
      </el-form-item>
      <el-form-item label="服务器IP地址：端口" prop="name">
        <add-input></add-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import AddInput from '../AddInput/index'
export default {
  props:['data'],
  data(){
    return{
      checked:true,
      //通讯协议
      ProtocolList:[
        {label:'普通串口',value:'serial'},{label:'4G DTU',value:'dtu'},
        {label:'Modbus',value:'modbus'},{label:'ZLWL',value:'zlwl'}
      ],
      //网络模式
      InternetList:[
        {label:'服务器',value:'server'},{label:'客户端',value:'client'}
      ],
      TransferProtocolList:[
        {label:'TCP',value:'tcp'},{label:'UDP',value:'udp'}
      ],
      list:{}
    }
  },
  components:{
    AddInput
  },
  watch:{
    data:{
      handler(newValue, oldValue){
        this.list=newValue
        this.list.enabled=this.list.enabled=='1'?true:false
        this.list.hb=this.list.hb=='1'?true:false
        this.list.id=this.list.id=='1'?true:false
      }
    }
  }
}
</script>
<style scoped>
.con {
  width: 80%;
  margin: 0 auto;
}
.Form-Input-Width {
  width: 5rem;
}
.Form-Buttom {
  margin-left: 0.2rem;
}
.checked{
  margin-left:1rem;
}
.Config-Buttom{
  display:table;
  margin: 30px auto;
  font-size: 14px;
  overflow: hidden;
}
</style>
